// extracted by mini-css-extract-plugin
export default {"container":"_2-pk","checkmark":"_23kn"};